var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{attrs:{"resizable":"","border":"","round":"","loading":_vm.loading,"columns":_vm.tableColumn,"data":_vm.tabelData,"size":"mini","height":"400"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }